
window.addEventListener('load', function () {
    $('.AjaxModal').on('submit', function (e) {
        console.log('Form capturado');
        e.preventDefault();

        var form = this;

        // 1) Pega a site key do <meta> (sem PHP no JS)
        var siteKeyMeta = document.querySelector('meta[name="recaptcha-site-key"]');
        var siteKey = siteKeyMeta ? siteKeyMeta.getAttribute('content') : '';

        if (!siteKey) {
            console.error('reCAPTCHA site key não encontrada no <meta name="recaptcha-site-key">');
            return;
        }
        if (!window.grecaptcha) {
            console.error('grecaptcha não carregado. Verifique o script da API no <head>.');
            return;
        }

        grecaptcha.ready(function () {
            grecaptcha.execute(siteKey, { action: 'submit' }).then(function (token) {
                // 2) Garante que existe e preenche o(s) input(s) com name correto
                var inputs = form.querySelectorAll('input[name="g-recaptcha-response"]');
                if (inputs.length === 0) {
                    var input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = 'g-recaptcha-response';
                    input.className = 'g-recaptcha-home';
                    form.appendChild(input);
                    inputs = form.querySelectorAll('input[name="g-recaptcha-response"]');
                }
                inputs.forEach(function (inp) { inp.value = token; });

                // (debug opcional) confira o que vai ser enviado:
                // console.log($(form).serialize());

                // 3) Envia via AJAX (igual ao seu)
                $.ajax({
                    url: $(form).attr('action'),
                    method: 'POST',
                    data: $(form).serialize(),
                    success: function (response) {
                        if (response.status === 'success_newsletter') {

                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                event: 'subscribe_submit',
                                meta_event_id: response.meta_event_id,
                                meta_event_name: 'Subscribe'
                            });

                            new bootstrap.Modal(document.getElementById('SuccessModal')).show();
                            $('#ModalTitleSuccess').text('Sucesso!');
                            $('#SuccessModal .modal-body').text('Inscrição realizada com sucesso! 🎉');
                            form.reset();
                            return;
                        }
                        if (response.status === 'success_contato') {

                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                event: 'contact_submit',
                                meta_event_id: response.meta_event_id,
                                meta_event_name: 'Contact'
                            });

                            new bootstrap.Modal(document.getElementById('SuccessModal')).show();
                            $('#ModalTitleSuccess').text('Sucesso!');
                            $('#SuccessModal .modal-body').text('Mensagem enviada com sucesso! 🎉');
                            form.reset();
                            return;
                        }
                        if (response.status === 'erro') {
                            new bootstrap.Modal(document.getElementById('ErrorModal')).show();
                            $('#ModalTitleError').text('Erro!');
                            $('#ErrorModal .modal-body').text('Erro na requisição, contate o administrador do site. ❌');
                        }
                    },
                    error: function () {
                        new bootstrap.Modal(document.getElementById('ErrorModal')).show();
                        $('#ModalTitleError').text('Erro!');
                        $('#ErrorModal .modal-body').text('Erro no servidor. Por favor, tente novamente mais tarde. ❌');
                    }
                })
                    .always(function () {
                        // Avisa o Loading
                        document.dispatchEvent(new CustomEvent('sac:finished', { detail: { formId: 'loadingForm' } }));
                    });
            });
        });
    });
});
